import type { AppSpecData } from '@wix/thunderbolt-symbols'

/**
 * @description - find all legacy builder components according to client spec map componentType:
 * Legacy components are:
 * - TPAWidget
 * - TPAGluedWidget
 * - TPASection
 * - TPAMultiSection
 * @param clientSpecMap - client spec map
 * @returns builder legacy components map
 */
export const getBuilderLegacyComponentsMap = (
	clientSpecMap: Record<string, AppSpecData>
): BuilderLegacyComponentsMap => {
	const result: BuilderLegacyComponentsMap = {}

	for (const spec of Object.values(clientSpecMap)) {
		if (!spec.widgets) {
			continue
		}

		for (const widget of Object.values(spec.widgets)) {
			const { componentType, refType } = widget.componentFields || {}

			if (componentType !== undefined && refType !== undefined) {
				result[componentType] = refType
			}
		}
	}

	return result
}

export type BuilderLegacyComponentsMap = Record<string, string>
